const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/users/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
import { Shield, Trash2, UserCheck, UserX } from "lucide-react";
export const Route = createFileRoute("/users/")({
  beforeLoad: args => requirePermission(Permissions.AdminUsers.ViewAll, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});